import { h } from 'preact'
import { useState } from 'preact/hooks'
import initializeForm from '../utilities/initializeForm'

import { formFields, formSchema } from './config'

import FormInput from '../elements/FormInput'

import sharedStyles from '../sharedStyles.module.scss'
import ChartContainer from '../../charts/ChartContainer/ChartContainer'
import BarChart from '../../charts/BarChart'
import formatNumber from '../../../utilities/formatNumber'

function calculate({ afterTaxIncome, age, inflation, retirementAge }) {
  const rate = inflation
  const monthlyReturn = rate / 100

  const months = Number(retirementAge) - Number(age)

  const assets = Number(afterTaxIncome)
  const expectedSavings =
    (assets * (Math.pow(1 + monthlyReturn, months) - 1)) / monthlyReturn

  const data = []

  for (let x = 1; x <= Number(retirementAge) - Number(age); x++) {
    const value =
      (assets * (Math.pow(1 + monthlyReturn, x) - 1)) / monthlyReturn

    data.push({
      year: `${x}`,
      value: value.toFixed(2),
    })
  }
  return data
}

export default function InsuranceNeedsForm({ formName }) {
  const [view, setView] = useState('form')
  const [chartData, setChartData] = useState(null)
  const { formValues, formErrors, handleInputChange, validateForm, resetForm } =
    initializeForm({
      initialValues: {
        age: '',
        retirementAge: '',
        afterTaxIncome: '',
        inflation: '1',
      },
      formSchema,
    })

  function submit() {
    validateForm().then(validFormData => {
      setChartData(calculate(validFormData))
      setView('chart')
    })
  }

  if (view === 'chart' && chartData) {
    return (
      <div>
        <p>
          Your projected after-tax income between now and retirement is $
          {formatNumber(chartData?.[chartData.length - 1]?.value || 0)}{' '}
        </p>
        <p>
          Many people are surprised to see their earning potential over time.
          Depending on your family’s unique financial needs upon your death,
          including funeral costs, education for your children and paying off
          the mortgage, your projected earnings can provide a basis for the
          amount of insurance you’d like your family to receive.
        </p>
        <ChartContainer
          edit={() => setView('form')}
          reset={() => {
            setView('form')
            resetForm()
          }}
        >
          <BarChart data={chartData} />
        </ChartContainer>
      </div>
    )
  }

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        submit()
      }}
      className={sharedStyles.Form}
    >
      {Object.entries(formFields).map(([key, input]) => {
        const id = `${formName}-${key}`
        return (
          <FormInput
            key={id}
            id={id}
            identifier={key}
            input={input}
            error={formErrors?.[key]}
            value={formValues?.[key]}
            handleInputChange={handleInputChange}
          />
        )
      })}
      <div className={sharedStyles.SubmitContainer}>
        <button type="submit" className="button dark">
          Calculate
        </button>
      </div>
    </form>
  )
}
